import React from 'react'
import {
  Button,
  MenuItem,
  Select,
  Slider,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'

import { swatchType } from '../../materialTypes'
import styles from '../../materials.module.scss'

interface Props extends swatchType {
  active: boolean
  onClickFn: () => void
}

const ValuePair = ({
  name,
  value,
}: {
  name: string
  value: string | number
}) => (
  <div className={styles.sValuePair}>
    <Typography className={styles.vPName}>{name} </Typography>
    <Typography className={styles.sMargin} variant="caption">
      {value}
    </Typography>
  </div>
)

const Swatch = ({
  order,
  name,
  chex,
  materialType,
  cieL,
  cieA,
  cieB,
  cieC,
  cieH,
  onClickFn,
  active,
  detail,
}: Props) => {
  // const [swData, setSwData] = React.useState<swatchType>({
  //   detail: '',
  //   id: 1,
  //   name: '',
  //   cieL: 0,
  //   cieA: 0,
  //   cieB: 0,
  //   cieC: 0,
  //   cieH: 0,
  //   cHex: '',
  //   code: '',
  //   order: 0,
  //   highlight: true,
  //   materialCatalogue: 0,
  //   materialType: 0,
  // })

  return !active ? (
    <div className={styles.swatchWrapper} onClick={() => onClickFn()}>
      <div className={styles.head}>
        <Typography variant="caption" className={styles.swatchOrder}>
          {order}
        </Typography>
        <div
          style={{
            backgroundColor: `${'#' + chex}`,
          }}
          className={styles.sColor}
        />
        <div>
          <Typography className={styles.sMargin} variant="h6">
            {name}
          </Typography>
          <Typography variant="caption">{materialType.name}</Typography>
        </div>
      </div>
      <div className={styles.colorGroup}>
        <ValuePair name="L" value={cieL.toFixed(2)} />
        <ValuePair name="a" value={cieA.toFixed(2)} />
        <ValuePair name="b" value={cieB.toFixed(2)} />
        <ValuePair name="C" value={cieC.toFixed(2)} />
        <ValuePair name="H" value={cieH.toFixed(2)} />
      </div>
      <div className={styles.colorGroup}>
        <ValuePair name="Hex" value={`${'#' + chex}`} />
      </div>
    </div>
  ) : // ) : (
  //   <div className={styles.swatchWrapperEdit}>
  //     <div
  //       style={{
  //         width: '25%',
  //         height: '100%',
  //         display: 'flex',
  //         flexDirection: 'column',
  //         justifyContent: 'space-evenly',
  //       }}
  //     >
  //       <div
  //         style={{
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'space-between',
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: '140px',
  //             height: '140px',
  //             backgroundColor: `${hex}`,
  //             borderRadius: '4px',
  //           }}
  //         />
  //         <div style={{ width: '50%', margin: '1rem' }}>
  //           <TextField
  //             label="name"
  //             size="small"
  //             style={{ margin: '.5rem 0', width: '100%' }}
  //             onChange={e => setSwData({ ...swData, name: e.target.value })}
  //           >
  //             {name}
  //           </TextField>
  //           <Select
  //             label="material type"
  //             value={'matTypes'}
  //             size="small"
  //             style={{ width: '100%' }}
  //           >
  //             <MenuItem value="matTypes">matTYpes</MenuItem>
  //           </Select>
  //           <div
  //             style={{
  //               display: 'flex',
  //               alignItems: 'center',
  //               margin: '.5rem',
  //             }}
  //           >
  //             <Typography variant="caption">HIghlight</Typography>
  //             <Switch size="small" />
  //           </div>
  //         </div>
  //       </div>
  //       <TextField
  //         label="detail"
  //         style={{ width: '100%' }}
  //         onChange={e => setSwData({ ...swData, details: e.target.value })}
  //       >
  //         {details}
  //       </TextField>
  //     </div>
  //     <div
  //       style={{
  //         width: '25%',
  //         height: '100%',
  //         display: 'flex',
  //         flexDirection: 'column',
  //         alignItems: 'flex-start',
  //         justifyContent: 'space-between',
  //         padding: '.5rem',
  //       }}
  //     >
  //       <Typography>Color</Typography>
  //       <TextField
  //         label="Hex"
  //         size="small"
  //         onChange={e => setSwData({ ...swData, hex: e.target.value })}
  //       >
  //         {hex}
  //       </TextField>
  //       <div
  //         style={{
  //           display: 'flex',
  //           width: '100%',
  //           justifyContent: 'space-between',
  //         }}
  //       >
  //         <ValuePair name="L" value={colorLabchL} />
  //         <ValuePair name="A" value={colorLabA} />
  //         <ValuePair name="B" value={colorLabB} />
  //         <ValuePair name="C" value={colorLchC} />
  //         <ValuePair name="H" value={colorLchH} />
  //       </div>
  //       <ValuePair
  //         name="RGB"
  //         value={`${colorRgbR} ${colorRgbG} ${colorRgbB}`}
  //       />
  //       <ValuePair name="Raw Hex" value={rawHex} />
  //     </div>
  //     <div
  //       style={{
  //         width: '25%',
  //         height: '100%',
  //         display: 'flex',
  //         flexDirection: 'column',
  //         alignItems: 'flex-start',
  //         justifyContent: 'space-between',
  //         padding: '.5rem',
  //       }}
  //     >
  //       <Typography>Normals</Typography>
  //       <Slider
  //         step={0.1}
  //         marks
  //         min={0}
  //         max={1}
  //         style={{ width: '100%', alignSelf: 'center' }}
  //         onChange={(e: Event) =>
  //           setSwData({ ...swData, normalStrength: e.target.value })
  //         }
  //       />
  //       <Button
  //         variant="contained"
  //         size="small"
  //         component="label"
  //         style={{ width: '90%', alignSelf: 'center' }}
  //         onChange={(e: Event) =>
  //           setSwData({ ...swData, normalMap: e.target.value })
  //         }
  //       >
  //         Select Normal Map
  //         <input type="file" hidden />
  //       </Button>
  //       <div style={{ display: 'flex', width: '100%' }}>
  //         <div style={{ width: '100%' }}>
  //           <Typography variant="subtitle2">Scale U</Typography>
  //           <Slider
  //             step={0.1}
  //             marks
  //             min={0}
  //             max={1}
  //             style={{ width: '80%' }}
  //             onChange={(e: Event) =>
  //               setSwData({ ...swData, normalSizeU: e.target.value })
  //             }
  //           />
  //         </div>
  //         <div style={{ width: '100%' }}>
  //           <Typography variant="subtitle2">Scale V</Typography>
  //           <Slider
  //             step={0.1}
  //             marks
  //             min={0}
  //             max={1}
  //             style={{ width: '80%' }}
  //             onChange={(e: Event) =>
  //               setSwData({ ...swData, normalSizeV: e.target.value })
  //             }
  //           />
  //         </div>
  //       </div>
  //     </div>
  //     <div
  //       style={{
  //         width: '25%',
  //         display: 'flex',
  //         height: '100%',
  //         flexDirection: 'column',
  //         alignItems: 'flex-start',
  //         justifyContent: 'space-between',
  //         padding: '.5rem',
  //       }}
  //     >
  //       <Typography>Metalness</Typography>
  //       <Slider
  //         step={0.1}
  //         marks
  //         min={0}
  //         max={1}
  //         style={{ width: '100%' }}
  //         onChange={(e: Event) =>
  //           setSwData({ ...swData, metalness: e.target.value })
  //         }
  //       />
  //       <Typography>Roughness</Typography>
  //       <Slider
  //         step={0.1}
  //         marks
  //         min={0}
  //         max={1}
  //         onChange={(e: Event) =>
  //           setSwData({ ...swData, roughness: e.target.value })
  //         }
  //       />
  //       <Button
  //         variant="contained"
  //         size="small"
  //         component="label"
  //         style={{ width: '90%', alignSelf: 'center' }}
  //         onChange={(e: Event) =>
  //           setSwData({ ...swData, roughnessMap: e.target.value })
  //         }
  //       >
  //         Select Roughness Map
  //         <input type="file" hidden />
  //       </Button>
  //       <div style={{ display: 'flex', alignSelf: 'flex-end' }}>
  //         <Button style={{ width: '50%', margin: '.5rem' }} size="small">
  //           cancel
  //         </Button>
  //         <Button
  //           variant="contained"
  //           style={{ width: '50%', margin: '.5rem' }}
  //           color="secondary"
  //           size="small"
  //         >
  //           save
  //         </Button>
  //       </div>
  //     </div>
  //   </div>
  // )
  null
}

export default Swatch
